/**
 * The names `ResizableSidebar` (in `@cowbell/moo`) publishes to the page.
 *
 * Copied rather than imported so that global styles and the nav can read them
 * without pulling the whole Moo library into the entry bundle.
 * `sidebar-contract.test.ts` here and `ResizableSidebar.spec.tsx` in the library
 * pin both copies to the same literals, so a rename on either side fails.
 */

/** Set on `<html>` while the Moo sidebar is open, holding its width. */
export const MOO_SIDEBAR_WIDTH_CSS_VAR = '--ask-moo-sidebar-width';

/** Set on `<body>` while the Moo sidebar is being drag-resized. */
export const MOO_SIDEBAR_RESIZING_CLASS = 'moo-sidebar-resizing';

/** True while the Moo sidebar is open in sidebar mode. Fullscreen and floating
 *  modes do not publish the width, so they read as closed. */
export function isMooSidebarOpen(): boolean {
  if (typeof document === 'undefined') return false;
  return (
    document.documentElement.style
      .getPropertyValue(MOO_SIDEBAR_WIDTH_CSS_VAR)
      .trim() !== ''
  );
}
